var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_6107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1952 0.904375C10.0209 0.828008 9.81523 0.864077 9.67608 0.996212L4.7355 5.66232H1.37037C1.1052 5.66232 0.890625 5.87689 0.890625 6.14202V12.8582C0.890625 13.1234 1.1052 13.3379 1.37037 13.3379H4.7355L9.67613 18.004C9.76702 18.0903 9.88553 18.1352 10.0055 18.1352C10.0697 18.1352 10.1343 18.1226 10.1952 18.0959C10.3714 18.0205 10.4852 17.8471 10.4852 17.6555V1.34477C10.4852 1.15313 10.3713 0.979797 10.1952 0.904375ZM9.52573 16.5424L5.25549 12.5096C5.16649 12.4253 5.04843 12.3785 4.92614 12.3785H1.85007V6.62171H4.92614C5.04843 6.62171 5.16649 6.57485 5.25549 6.49052L9.52573 2.45788V16.5424Z",
    fill: "url(#paint0_linear_57_6107)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6246 0.956271C17.4081 0.800254 17.1088 0.849007 16.9547 1.06309C16.7991 1.27766 16.8469 1.5775 17.0615 1.73303C19.5529 3.53763 21.0398 6.44132 21.0398 9.50004C21.0398 12.5588 19.5528 15.4624 17.0615 17.267C16.8469 17.4226 16.7991 17.7224 16.9547 17.937C17.0484 18.0663 17.195 18.1351 17.3435 18.1351C17.441 18.1351 17.5393 18.1056 17.6246 18.0438C20.3638 16.0593 21.9993 12.8652 21.9993 9.50004C21.9993 6.13491 20.3638 2.94077 17.6246 0.956271Z",
    fill: "url(#paint1_linear_57_6107)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0125 3.81705C14.79 3.6765 14.4925 3.74351 14.351 3.96789C14.21 4.19182 14.2775 4.48793 14.5019 4.62938C16.1917 5.69284 17.2008 7.51382 17.2008 9.50021C17.2008 11.4866 16.1917 13.3076 14.5019 14.371C14.2775 14.5125 14.21 14.8086 14.351 15.0325C14.4424 15.1777 14.5984 15.2569 14.7577 15.2569C14.8448 15.2569 14.9334 15.2331 15.0126 15.1834C16.9834 13.9429 18.1603 11.8188 18.1603 9.50025C18.1603 7.18173 16.9834 5.05762 15.0125 3.81705Z",
    fill: "url(#paint2_linear_57_6107)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.157 7.19651C12.9444 7.03771 12.6441 7.08268 12.4857 7.29442C12.3274 7.50711 12.3714 7.8079 12.5836 7.96576C13.0793 8.33491 13.3632 8.89381 13.3632 9.50006C13.3632 10.1063 13.0792 10.6652 12.5836 11.0344C12.3714 11.1922 12.3274 11.493 12.4857 11.7057C12.5799 11.8322 12.7242 11.8987 12.8708 11.8987C12.9701 11.8987 13.0709 11.8678 13.1571 11.8036C13.8978 11.2522 14.3227 10.4122 14.3227 9.50006C14.3227 8.58789 13.8977 7.74794 13.157 7.19651Z",
    fill: "url(#paint3_linear_57_6107)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_57_6107",
    x1: 0.890625,
    y1: -6.23835,
    x2: 23.2487,
    y2: 1.5681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15926,
    stopColor: "#FEFFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661725,
    stopColor: "#E6D189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#291A15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_57_6107",
    x1: 16.8633,
    y1: -6.23831,
    x2: 29.8375,
    y2: -3.81334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15926,
    stopColor: "#FEFFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661725,
    stopColor: "#E6D189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#291A15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_57_6107",
    x1: 14.2773,
    y1: -0.991739,
    x2: 23.9923,
    y2: 1.06744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15926,
    stopColor: "#FEFFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661725,
    stopColor: "#E6D189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#291A15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_57_6107",
    x1: 12.3906,
    y1: 5.12827,
    x2: 17.1376,
    y2: 6.32981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15926,
    stopColor: "#FEFFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661725,
    stopColor: "#E6D189"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#291A15"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_6107"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.1078,
    height: 17.2704,
    fill: "white",
    transform: "translate(0.890625 0.864807)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSound);
export default __webpack_public_path__ + "static/media/sound.fbb2668fc3b25138e3df5044fe2d011d.svg";
export { ForwardRef as ReactComponent };